import React from 'react';
import {MaintenancePage} from './components/MaintenancePage';
import {maintenanceMode} from './config/maintenance';

function App() {
  if (maintenanceMode) {
    return <MaintenancePage />;
  }

  return null;
}

export default App;